import {styled} from "@mui/material/styles";
import {useDrawingArea} from "@mui/x-charts/hooks";
import Paper from "@mui/material/Paper";
import {Box, Grid, Stack, Typography, Button} from "@mui/material";
import {PieChart} from "@mui/x-charts/PieChart";
import React from "react";

export const ConfirmationCallGraphs = ({confirmationCalls, showUnconfirmedOnly, setShowUnconfirmedOnly}) => {

    const colors = ['31, 163, 84', '255, 76, 134']
    const data1 = confirmationCalls.map((el, idx) => ({
        ...el,
        color: `rgba(${colors[idx]})`,
        bg: `rgba(${colors[idx]}, 0.1)`
    }));
    const data2 = confirmationCalls.map((el, idx) => ({...el, color: `rgba(${colors[idx]}, 0.1)`}));

    const leadsCount = data1.reduce((acc, el) => acc + el.value, 0)
    const percentCompleted = (Boolean(leadsCount) ? Math.round(100 * data1[0].value / leadsCount) : 0) + '%';


    function PieCenterLabel1({children}) {
        const StyledText = styled('text')(({theme}) => ({
            fill: '#2B3033',
            textAnchor: 'middle',
            dominantBaseline: 'central',
            fontSize: 26,
            lineHeight: 30,
            fontWeight: 500,
        }));
        const {width, height, left, top} = useDrawingArea();
        return (
            <StyledText textLength="auto" x={left + width / 2} y={(top + height / 2) - 20}>
                {children}
            </StyledText>
        );
    }

    function PieCenterLabel2({children1, children2}) {
        const StyledText = styled('text')(({theme}) => ({
            textAnchor: 'middle',
            dominantBaseline: 'central',
            fontSize: 50,
            lineHeight: 30,
            fontWeight: 500,
            letterSpacing: '0.05px'
        }));
        const {width, height, left, top} = useDrawingArea();
        return (
            <StyledText fill={'rgb(31, 163, 84)'} textLength="auto" x={(left + width / 2)} y={(top + height / 2) + 20}>
                {children1}
            </StyledText>
        );
    }

    //pie chart end
    const ItemChart = styled(Paper)(({theme}) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : 'transparent',
        ...theme.typography.body2,
        color: theme.palette.text.secondary,
        boxShadow: 'none'
    }));
    return (
        <Box sx={{height:'100%',width:'100%'}}>
            <Box sx={{background:'rgba(179, 215, 254, 1)',py:2.4,width:'100%'}}>
                <Typography variant="div" component="div" fontSize={'14px'} fontWeight="500" lineHeight={'18px'}  letterSpacing={'0.5px'} mr={3} color={'#2B3033'} textAlign={'center'}>
                    Company Stats
                </Typography>
            </Box>
            <Box sx={{background:'#F0F7FF',p:2,height:'calc(100vh - 245px)'}}>
                <Box sx={{padding: '10px 20px',background:'#fff',borderRadius:'10px',boxShadow:'0 10px 20px 0 rgba(0,0,0,0.05)'}}>
                    <ItemChart className="DEF_ratio_chart">
                        <Grid container columnSpacing={2} sx={{alignItems: 'center', justifyContent: 'space-between'}}>
                            <Grid item xs={12} md={6} lg={6}
                                  sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between',width:'200px'}}>
                                    <PieChart
                                        series={[
                                            {data: data1, innerRadius: 180, paddingAngle: 1, outerRadius: 176},
                                            {data: data2, innerRadius: 180, paddingAngle: 1,outerRadius: 126}

                                        ]}
                                        margin={{right: 0}}
                                        width={380}
                                        height={200}
                                        slotProps={{
                                            legend: {
                                                hidden: true
                                            }
                                        }}
                                    >
                                        <PieCenterLabel1>Total Ratio</PieCenterLabel1>
                                        <PieCenterLabel2 children1={percentCompleted}/>
                                    </PieChart>
                                </Box>

                            </Grid>
                            <Grid item xs={12} md={6} lg={6} textAlign={'left'}>
                                <Box className="infoCart_scroll">
                                    <Box sx={{py: 0.5, px: 1, mb: 0.3}}>
                                        <Typography className="label_leads_state" variant="span" component="div"
                                                    textTransform={'uppercase'}>
                                            Total Confirmation Calls
                                        </Typography>
                                        <Typography className="val_leads_state" variant="span" component="div"
                                                    sx={{color: "#2B3033"}} fontWeight={600}>
                                            {leadsCount}
                                        </Typography>
                                    </Box>
                                    {data1.map(el => (
                                        <Box key={el.value} sx={{py: 0.5, px: 1, mb: 0.3}}>
                                            <Typography className="label_leads_state" gutterBottom variant="span"
                                                        component="div" textTransform={'uppercase'}>
                                                {el.label}
                                            </Typography>
                                            <Stack direction="row" spacing={5} sx={{justifyContent: 'space-between'}}>
                                                <Typography 
                                                    className="val_leads_state" 
                                                    gutterBottom 
                                                    variant="span"
                                                    component="div" 
                                                    sx={{
                                                        color: el.color,
                                                        cursor: el.label === 'Not Completed' ? 'pointer' : 'default',
                                                        textDecoration: el.label === 'Not Completed' ? 'underline' : 'none',
                                                        '&:hover': el.label === 'Not Completed' ? {
                                                            opacity: 0.8,
                                                            transform: 'scale(1.05)'
                                                        } : {}
                                                    }}
                                                    onClick={el.label === 'Not Completed' ? () => setShowUnconfirmedOnly(!showUnconfirmedOnly) : undefined}
                                                >
                                                    {el.value}
                                                </Typography>
                                            </Stack>
                                        </Box>
                                    ))}
                                    
                                    {/* Show All Jobs Button - appears when filtering unconfirmed jobs */}
                                    {showUnconfirmedOnly && (
                                        <Box sx={{py: 1, px: 1, mt: 1}}>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={() => setShowUnconfirmedOnly(false)}
                                                sx={{
                                                    width: '100%',
                                                    borderColor: '#007BFF',
                                                    color: '#007BFF',
                                                    borderRadius: '8px',
                                                    textTransform: 'none',
                                                    fontWeight: 500,
                                                    fontSize: '12px',
                                                    py: 0.5,
                                                    '&:hover': {
                                                        backgroundColor: '#007BFF',
                                                        color: '#fff',
                                                        borderColor: '#007BFF'
                                                    }
                                                }}
                                            >
                                                Show All Jobs
                                            </Button>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>

                    </ItemChart>
                </Box>
            </Box>


        </Box>
    )
}